import { Typography } from "@mui/material";
import { Link } from "react-router-dom";

export const Card = ({ order }) => {
  const { image, name, price, productNumber, id, cantidad, barcode, discount, price_with_discount } = order;

  return (
    <>
      {/* <!-- BEING ORDER ITEM CARD --> */}
      <div className='checkout-order__item'>
        <Link to={`/product/${id}`}>
          <a className='checkout-order__item-img'>
            <img
              src={image}
              // className='js-img'
              alt={name}
              style={{ width: "100px", height: "100px" }}
            />
          </a>
        </Link>
        <div className='checkout-order__item-info'>
          <Link to={`/product/${id}`}>
            <a className='title6'>
              {name} <span>x{cantidad}</span>
            </a>
          </Link>
          {/* <span className='checkout-order__item-price'>
           
          </span> */}
          <Typography
            variant="subtitle1"
            sx={{ fontSize: '13px', textDecorationLine: price_with_discount ? 'line-through' : 'none' }}
            color="black"
          >
            {price_with_discount ? `$${price * cantidad}` : null}
          </Typography>
          <Typography
            sx={{
              fontSize: '15px',
              color: price_with_discount ? 'red' : 'black'
            }}>
            ${(price_with_discount ? price_with_discount * cantidad : price * cantidad).toFixed(2)}
          </Typography>
          {
            discount > 0 && (
              <span className='checkout-order__item-discount'>
                -{discount}%
              </span>
            )
          }
          <span className='checkout-order__item-num'>SKU: {barcode}</span>
        </div>
      </div>
      {/* <!-- ORDER ITEM CARD EOF --> */}
    </>
  );
};
